import React from 'react';
import {PatientPhoneNumber as PatientPhoneNumberDto} from '@/api/dto/client-profile';
import DisplayHelpers from '@/helpers/display_helpers';

type Props = {
  phoneNumber: PatientPhoneNumberDto | undefined;
  /** Optional content rendered inline next to the formatted number (e.g., a copy button). */
  children?: React.ReactNode;
  /** Fallback rendered when the phone number is missing/empty. Defaults to '-'. */
  emptyFallback?: React.ReactNode;
};

/**
 * Centralized renderer for patient phone numbers.
 *
 * Renders the formatted number and, when the phone type is 'mobile', appends a
 * '(cell)' line below it. Callers can pass children (such as <CopyButton>)
 * to render alongside the number on the same line.
 */
const PatientPhoneNumber = ({ phoneNumber, children, emptyFallback = '-' }: Props) => {
  const formatted = DisplayHelpers.formatPatientPhoneNumber(phoneNumber)?.trim();

  if (!formatted) {
    return <>{emptyFallback}</>;
  }

  return (
    <>
      <span style={{display: 'inline-flex', alignItems: 'center', gap: '4px', whiteSpace: 'nowrap'}}>
        {formatted}
        {children}
      </span>
      {phoneNumber?.type === 'mobile' && <div>(cell)</div>}
    </>
  );
};

export default PatientPhoneNumber;
